'use strict';

const $ = window.jQuery;

export default class WebinarsReplays {
    constructor() {
        $('.webinars-slider').slick({
            fade: true,
            prevArrow: $('.webinar-prev'),
            nextArrow: $('.webinar-next'),
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        adaptiveHeight: true
                    }
                }
            ]
        });

        $('.replays-slider').slick({
            fade: true,
            prevArrow: $('.replay-prev'),
            nextArrow: $('.replay-next'),
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        adaptiveHeight: true
                    }
                }
            ]
        });
    }
}
